import * as React from 'react';
import { useState, useEffect } from 'react';
import {Field, Form} from 'formik';
import * as Yup from 'yup';
import FormikForm from '~/lib/forms/FormikForm';
import SaleHeader from './SaleHeader';
import FooterWrapper from '~/common/elements/mobile/FooterWrapper';
import BodyWrapper from '~/common/elements/mobile/BodyWrapper';
import Button from '~/common/elements/mobile/Button';
import {buttonColor, buttonSize, buttonStyle} from '~/common/elements/mobile/consts';
import Input from '~/common/controls/Input';
import PageMobileWrapper from '~/common/elements/mobile/PageMobileWrapper';


const saleSchema = Yup.object().shape({
  code: Yup.string().required('Required').test('len', 'Must be 6 or 12 characters long', val => val && (val.length === 6 || val.length === 12)),
});

type Props = {
  initialValues: any,
  onBack: any,
  onHelp: any,
  onSubmit: any,
  setFormData: any,
  actionKeyBack: number,
}

const SaleStepCode = (props : Props) => {
  const {
    initialValues, onBack, onHelp, onSubmit, setFormData, actionKeyBack,
  } = props;
  const [isSubmit, setSubmit] = useState(false);
  const [isInitialValid, setInitialValid] = useState(false);

  const handleBack = () => {
    if (onBack) onBack();
  };

  const handleHelp = () => {
    if (onHelp) onHelp(actionKeyBack);
  };

  const handleOnSubmit = (data) => {
    setSubmit(true);
    if (setFormData) setFormData(data);
    return onSubmit(saleSchema.cast(data));
  };

  useEffect(() => {
    saleSchema.isValid(initialValues).then(valid => {
      if (valid) setInitialValid(true)
    });
  }, [])

  return (
    <FormikForm
      initialValues={initialValues}
      onSubmit={handleOnSubmit}
      validationSchema={saleSchema}
      isInitialValid={isInitialValid}
      render={(propsForm) => {

        return (
          <PageMobileWrapper>
            <SaleHeader
              onBack={handleBack}
              onHelp={handleHelp}
              title='Enter Relay Code'
            />

            <BodyWrapper>
              <Form className="form__cont">
                <Field
                  name="code"
                  label="Enter Relay Code"
                  type="text"
                  component={Input}
                  className="input input--sm"
                />

              </Form>
            </BodyWrapper>
            <FooterWrapper>
              <Button
                title={isSubmit ? 'Please Wait...' : propsForm.isValid ? 'Send' : 'Complete fields to continue'}
                buttonStyle={isSubmit ? buttonStyle.SECN : propsForm.isValid ? buttonStyle.OUTL_LITE : buttonStyle.LARY}
                buttonSize={buttonSize.LG}
                buttonColor={propsForm.isValid ? buttonColor.PRIM : null}
                onClick={!isSubmit ? propsForm.submitForm : null}
              />
            </FooterWrapper>
          </PageMobileWrapper>
        );
      }}
    />
  );
};

export default SaleStepCode;
